(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
  document.querySelector('#button-video').addEventListener('click', function(e){
    document.getElementById('lightbox-video').classList.add('fadeIn');
    document.getElementById('button-video').classList.add('hide');
    var videoURL = document.getElementById('video').src;
    videoURL += "?autoplay=1"; 
    document.getElementById('video').src=videoURL; 
  });
  document.querySelector('#close-btn-video').addEventListener('click', function(e){
    document.getElementById('lightbox-video').classList.remove('fadeIn');
    document.getElementById('button-video').classList.remove('hide');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-collection-default"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function (event) {
  $(document).on("click", ".gp-view-mode-grid", function (e) {
    e.preventDefault();
    if (!document.querySelector(".gp-view-mode-grid").classList.contains("active")) {
      document.querySelector(".gp-view-mode-grid").classList.add("active");
      document.querySelector(".gp-view-mode-list").classList.remove("active");
      viewModeGrid();
    }
  });
  $(document).on("click", ".gp-view-mode-list", function (e) {
    e.preventDefault();
    if (!document.querySelector(".gp-view-mode-list").classList.contains("active")) {
      document.querySelector(".gp-view-mode-list").classList.add("active");
      document.querySelector(".gp-view-mode-grid").classList.remove("active");
      viewModeList();
    }
  });
});
function viewModeGrid() {
  var x,
    i;
  x = document.querySelectorAll(".gp-products");
  for (i = 0; i < x.length; i++) {
    x[i].classList.remove("viewing-list");
    x[i].classList.add("viewing-grid");
  }
}
function viewModeList() {
  var x,
    i;
  x = document.querySelectorAll(".gp-products");
  for (i = 0; i < x.length; i++) {
    x[i].classList.add("viewing-list");
    x[i].classList.remove("viewing-grid");
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-collection-with-main-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(e) {
    if ($(window).width() < 768) {
      $('[data-section-type="gp-collection-with-main-image"] .products-on-page').not('.slick-initialized').slick({
        slidesToShow: 2,
        dots: false,
        arrows: true,
        draggable: true,
        prevArrow: '<i class="theme-iconback"></i>',
        nextArrow: '<i class="theme-iconnext"></i>',
        focusOnSelect: true,
        infinite: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-cookie-popup"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var e = document.querySelector(".cookie-popup"),
        o = e.getAttribute("data-cookiedata"),
        t = 1e3 * o.TimeStart;
    setTimeout(() => {
        if ("accepted" == getCookie("gpslus_cookies_") || 0 == e.length) return;
        e.classList.add("popupCookie_show"),
          document.querySelector(".clickAccept").addEventListener("click", (t) => {
            t.preventDefault(), e.classList.remove("popupCookie_show"), setCookie("gpslus_cookies_", "accepted", o.continueDay);
          });
        },
    t);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-faqs"]) return;
  try {
    

document.querySelectorAll( '.nav-tabs-faqs li a').forEach ( (a) =>{
  a.addEventListener('click', function() {
      $('.tab-pane').removeClass('active');
      var href = $(this).data('id');
      var class_faqs = $('.tab-pane.'+ href);
      $('.nav-tabs-faqs li.active').removeClass('active');
      $(this).parent().addClass('active');
      $(this).next().addClass('active');
      class_faqs.addClass('active'); 
    });
});


  document.querySelectorAll( '.faq-title').forEach ( (a) =>{
    a.addEventListener('click', function() {
      var questionDiv = $('.faq-title');
      var answerDiv = $('.faq-content');
      if ($(this).next().hasClass('openFAQ')) {
        $(this).removeClass('active');
        $(this).next().removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
      } else if ($(answerDiv).hasClass('openFAQ')) {
        $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
        $(questionDiv).removeClass('active');
        $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
        $(this).addClass('active');
      } else {
        $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
        $(this).addClass('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-popup-newsletter"]) return;
  try {
    
class newsletterDialog extends HTMLElement {
  constructor() {
    super();
    var display_on_mobile = this.getAttribute("data-mobile")

    if (this.classList.contains("show-on-mobile")) {
      this.show(this);
    } else {
      if (window.innerWidth > 767) {
        this.show(this);
      }
    }
    this.querySelector('#dont_show').addEventListener('click', this.dontShowPopUp.bind(this));
    this.querySelector('#close-popup').addEventListener('click', this.hide.bind(this));

    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(container) { 
    if (container != document.getElementById('newsletter-popup')) {
      document.getElementById('newsletter-popup').setAttribute('open', '');
      return
    }
    setTimeout(function() {
      if (document.getElementById('newsletter-popup').classList.contains('test-mode')) {
          document.getElementById('newsletter-popup').setAttribute('open', '')
      } else {
        if(getCookie('gpslus_newsletterpopup') != 'nevershow'){
          document.getElementById('newsletter-popup').removeAttribute('open')
        }
      }
    }, document.getElementById('newsletter-popup').getAttribute("data-delay"));
  }


  dontShowPopUp() {
    if(this.querySelector('#dont_show').checked) {
      var d = new Date();
      d.setTime(d.getTime() + (24*60*60*1000*10));
      var expires = "expires="+d.toUTCString();
      document.cookie = 'gpslus_newsletterpopup' + "=" + 'nevershow' + ";Secure; " + expires;
    } else {
      document.cookie = 'gpslus_newsletterpopup' + "= '';Secure; -1";
    }
  }
  hide() {
    this.removeAttribute('open')
  }
}
customElements.define('newsletter-dialog', newsletterDialog)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-popup-recommendation"] && !Shopify.designMode) return;
  try {
    
class recommendPopup extends HTMLElement {
  constructor() {
    super();
    this.lusionRecommendedProducts();
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.closeRecommendedProductsPopup();
    });

    this.querySelector('.recommended-products .mfp-close').addEventListener('click',  this.closeRecommendedProductsPopup.bind(this)
    );

    ['shopify:section:select', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach( evt => 
        this.addEventListener(evt, this.lusionRecommendedProducts.bind(this), false)
    );
  }


  lusionRecommendedProducts() {
    var time_start = document.querySelector('.recommended-popup').getAttribute('data-start'); 
    if(getCookie('gpslus_recommended_product').length === 0 && getCookie('gpslus_recommended_product') != 'nevershow'){
      setTimeout(function () {
        document.querySelector('.recommended-products').classList.add('active');
        document.querySelector('.recommended-products').setAttribute('open', 
        '');
      }, time_start);
    }
  }

  closeRecommendedProductsPopup(){
    this.removeAttribute('open')
    document.querySelector('.recommended-popup').classList.remove('active');
    var d = new Date();
    var time_day = document.querySelector('.recommended-popup').getAttribute('data-day');
    d.setTime(d.getTime() + (time_day));
    var expires = "expires="+d.toUTCString();
    document.cookie = 'gpslus_recommended_product' + "=" + 'nevershow' + ";SameSite=None;Secure;" + expires;
  }
}
customElements.define('recommend-popup', recommendPopup)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-related"]) return;
  try {
    
class relatedProduct extends HTMLElement {
  constructor() {
    super();

    this.limit = this.getAttribute("data-limit")

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $('related-product .product-related').on('init', function (event, slick) {
        var arrow = $('.product-related.slick-slider .slick-arrow')
        var height_img = $('.product-related .image').height();
        var height_arrow = arrow.height() + 2;
        var top = (height_img/2) - (height_arrow/2);
        arrow.css('top', top+'px')
      });

      $('related-product .product-related').slick({
          slidesToShow: this.limit,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          fade: false,
          adaptiveHeight: true,
          prevArrow: '<i class="theme-iconback"></i>',
          nextArrow: '<i class="theme-iconnext"></i>',
          pauseOnHover: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            }
          ]
      });

    }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }

}

customElements.define("related-product", relatedProduct);

window.addEventListener("resize" , function() {
  var arrow = $('.product-related.slick-slider .slick-arrow')
  var height_img = $('.product-related .image').height();
  var height_arrow = arrow.height() + 2;
  var top = (height_img/2) - (height_arrow/2);
  arrow.css('top', top+'px')
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-tab-widget"] && !Shopify.designMode) return;
  try {
    
function initMedia() {
  if($('[data-section-type="gp-product-tab"] .slick-products')) {
    var itemPerSlide = $('[data-section-type="gp-product-tab"] .slick-products').data('items');
    var itemPerSlideTablet = $('[data-section-type="gp-product-tab"] .slick-products').data('items-tablet');
    var itemPerSlideMobile = $('[data-section-type="gp-product-tab"] .slick-products').data('items-mobile');
    var dataRow = $('[data-section-type="gp-product-tab"] .slick-products').data('slide-row');
    var arrow = $('[data-section-type="gp-product-tab"] .slick-products').data('arrow');
    var hover_effect_product = $('[data-section-type="gp-product-tab"] .slick-products').data('hover-efect');
    var collection_banner = $('[data-section-type="gp-product-tab"] .slick-products').data('collection-banner');
    var dataRowMobile = 1;
    if (arrow == undefined) {
      arrow = true;
    }
    if (dataRow == undefined) {
      dataRow = 1;
    }
    if (hover_effect_product == 'style-14' ) {
      arrow = false;
      dataRow = 2;
    }
    if (itemPerSlide < 3) {
      itemPerSlideTablet = itemPerSlide;
    }
    $('[data-section-type="gp-product-tab"] .slick-products').not('.slick-initialized').slick({
      slidesToShow: itemPerSlide,
      slidesToScroll: 1,
      arrows: arrow,
      dots: false,
      fade: false,
      rows: dataRow,
      prevArrow: '<i class="theme-iconback"></i>',
      nextArrow: '<i class="theme-iconnext"></i>',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: itemPerSlideTablet
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: itemPerSlideMobile
          }
        }
      ]
    });

  }
}
$(window).on('resize', function(){
    var arrow = $('.slick-products.slick-slider .slick-arrow')
    var height_img = $('.slick-products .image').height();
    var height_arrow = arrow.height() + 2;
    var top = (height_img/2) - (height_arrow/2);
    arrow.css('top', top+'px');
})
initMedia();
['shopify:section:select', 'shopify:section:load', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach( evt => 
  document.addEventListener(evt, function() {
      initMedia()
  })
);
$(document).on('click', '.nav-tabs li a', function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $(this).parent().siblings().removeClass('active');
    $('.tab-pane'+ href).siblings().removeClass('active');
    $(this).parent().addClass('active');
    $('.tab-pane'+ href).addClass('active');
    $('.tab-pane'+ href).find('.slick-slider').slick('setPosition');
  });

  $(document).on('change', '.mobile-tab select', function() {
    var val = $(this).val();
    $('.tab-pane'+ val).siblings().removeClass('active');
    $('.tab-pane'+ val).addClass('active');
    $('.tab-pane'+ val).find('.slick-slider').slick('setPosition');
  });

document.addEventListener("DOMContentLoaded", function(event) {
  event.preventDefault();
  $(window).on('resize', function(){
      var arrow = $('.slick-products.slick-slider .slick-arrow')
      var height_img = $('.slick-products .image').height();
      var height_arrow = arrow.height() + 2;
      var top = (height_img/2) - (height_arrow/2);
      arrow.css('top', top+'px');
  })
  
  window.onload = function exampleFunction() {
    function topArrow() {
      var arrow = $('.product-grid.product-grid-slider.slick-products.slick-slider:not(.slick-vertical) .slick-arrow');
      var height_img = $('.product-grid.product-grid-slider.slick-products .product-card-item .image').height();
      var height_arrow = arrow.height() + 2;
      var top = (height_img/2) - (height_arrow/2);
      arrow.css('top',top+'px')
    }
    function topArrowRelatedProduct() {
      var arrow = $('.slick-related.slick-slider:not(.slick-vertical) .slick-arrow');
      var height_img = $('.slick-related .product-card-item .image').height();
      var height_arrow = arrow.height() + 2;
      var top = (height_img/2) - (height_arrow/2);
      arrow.css('top',top+'px')
    }
    function topArrowMobile() {
      var arrow = $('.single-slider-type-2 .slick-slider .slick-arrow');
      var height_img = $('.single-slider-type-2 .content-single-inner .img-product').height();
      var height_arrow = arrow.height();
      var top = height_img - height_arrow;
      arrow.css('top',top+'px')
    }
    function middleArrowProductWithContent() {
      if ($(window).width() < 1025) {
        var arrow = $('.gp-product-with-content.layout-in-image .slick-arrow');
        var height_img = $('.gp-product-with-content.layout-in-image .img').height();
        var height_arrow = arrow.height() + 2;
        var bottom = (height_img/2) - (height_arrow);
        arrow.css('bottom',bottom+'px')
      }
    }
    topArrowMobile();
    topArrow();
    topArrowRelatedProduct();
    middleArrowProductWithContent();

    $( window ).resize(function() {
      setTimeout(function() {
        topArrow();
        topArrowMobile();
        topArrowRelatedProduct();
        middleArrowProductWithContent();
      }, 100);
    });
  }
}) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-template-1-column"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-template-2-columns-left"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-widget"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(e) {
  $('.paginate-product .load-more-products').on('click', function(){
    var $this = $(this);
    var next_url = $this.data('next-url');
    var id_collection_product = $this.parent().parent().attr('id');
    var products_on_page = $('#'+id_collection_product).find('.products-on-page');
    $.ajax({
      url: next_url,
      type:'GET',
      dataType:'html',
      beforeSend: function () {
        $this.after('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
        $this.hide();
      },
      success: function (data) {
        var news_product = $(data).find('#'+id_collection_product).find('.products-on-page');
        var new_url = $(data).find('#'+id_collection_product).find('.load-more-products').data('next-url');
        $this.parent().find('.lds-ellipsis').remove();
        if(new_url){
          $this.show();
        }
        products_on_page.append(news_product.html());
        $this.data('next-url',new_url);
      }
    });
  });
  function initMedia() {
    if($('[data-section-type="gp-product-widget"] .slick-products')) {
      var itemPerSlide = $('[data-section-type="gp-product-widget"] .slick-products').data('items');
      var itemPerSlideTablet = $('[data-section-type="gp-product-widget"] .slick-products').data('items-tablet');
      var itemPerSlideMobile = $('[data-section-type="gp-product-widget"] .slick-products').data('items-mobile');
      var dataRow = $('[data-section-type="gp-product-widget"] .slick-products').data('slide-row');
      var arrow = $('[data-section-type="gp-product-widget"] .slick-products').data('arrow');
      var hover_effect_product = $('[data-section-type="gp-product-widget"] .slick-products').data('hover-efect');
      var collection_banner = $('[data-section-type="gp-product-widget"] .slick-products').data('collection-banner');
      var dataRowMobile = 1;
      $('[data-section-type="gp-product-widget"] .slick-products').on('init', function (event, slick) {
        var arrow = $('.slick-products.slick-slider .slick-arrow')
        var height_img = $('.slick-products .image').height();
        var height_arrow = arrow.height() + 2;
        var top = (height_img/2) - (height_arrow/2);
        arrow.css('top', top+'px')
      });
      if (arrow == undefined) {
        arrow = true;
      }
      if (dataRow == undefined) {
        dataRow = 1;
      }

      if (itemPerSlide < 3) {
        itemPerSlideTablet = itemPerSlide;
      }
      $('[data-section-type="gp-product-widget"] .slick-products').not('.slick-initialized').slick({
        slidesToShow: itemPerSlide,
        slidesToScroll: 1,
        arrows: arrow,
        dots: false,
        fade: false,
        rows: dataRow,
        prevArrow: '<i class="theme-iconback"></i>',
        nextArrow: '<i class="theme-iconnext"></i>',
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: itemPerSlideTablet
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: itemPerSlideMobile
            }
          }
        ]
      });

    }
  }
  $(window).on('resize', function(){
      var arrow = $('.slick-products.slick-slider .slick-arrow')
      var height_img = $('.slick-products .image').height();
      var height_arrow = arrow.height() + 2;
      var top = (height_img/2) - (height_arrow/2);
      arrow.css('top', top+'px');
  })
  initMedia();
  ['shopify:section:select', 'shopify:section:load', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach( evt => 
    document.addEventListener(evt, function() {
        initMedia()
    })
);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
      var height = window.innerHeight;
      document.querySelector(".gp-404-template").style.minHeight = height + 'px';
      document.querySelector(".gp-404-content-wrapper").style.minHeight = height + 'px';
      window.addEventListener("resize", function() { 
        var height = window.innerHeight;
        document.querySelector(".gp-404-template").style.minHeight = height + 'px';
        document.querySelector(".gp-404-content-wrapper").style.minHeight = height + 'px';
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({
        note: event.target.value
      });
      fetch(`${
        routes.cart_update_url
      }`, {
        ...fetchConfig(),
        ...{
          body
        }
      });
    }, 300))
  }
}

customElements.define('cart-note', CartNote);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function(e) {
  const wrapper = document.querySelector('.facets__wrapper');
  const content = document.querySelector('.filter-content');
  const button = document.getElementById('js-toggle-filter');
  let open = true;
  if (open) {
    wrapper.style.height = `${content.getBoundingClientRect().height}px`;
  }


  function toggleOpen () {
    if (open) {
        wrapper.style.height = '0px';
        open = false;
    } else {
      const height = content.getBoundingClientRect().height;
      wrapper.style.height = `${height}px`;
      open = true;
    }
  }

  button.addEventListener('click', toggleOpen);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.limit = this.getAttribute("data-limit")
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            $('product-recommendations .product-recommendations__list').on('init', function (event, slick) {
                var arrow = $('.product-recommendations__list.slick-slider .slick-arrow');
                var height_img = $('.product-recommendations__list .image').height();
                var height_arrow = arrow.height() + 2;
                var top = (height_img/2) - (height_arrow/2);
                arrow.css('top', top+'px')
            });
            $('product-recommendations .product-recommendations__list').not('.slick-initialized').slick({
              slidesToShow: this.limit,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              fade: false,
              adaptiveHeight: true,
              prevArrow: '<i class="theme-iconback"></i>',
              nextArrow: '<i class="theme-iconnext"></i>',
              pauseOnHover: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
            });

            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  window.addEventListener("resize" , function() {
    var arrow = $('.product-recommendations__list.slick-slider .slick-arrow');
    var height_img = $('.product-recommendations__list .image').height();
    var height_arrow = arrow.height() + 2;
    var top = (height_img/2) - (height_arrow/2);
    arrow.css('top', top+'px')
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-popup"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event) {
    if (document.getElementsByClassName('sale_popup').length > 0) {
      var e = document.querySelector(".gp-sale-popup"),
          r = document.getElementById("sale-popup-data");
          json = JSON.parse(r.textContent);
      function t(e, r) {
        return Math.floor(Math.random() * (r - e)) + e;
      }
      (arrImage = json.image),
      (arrUser = json.users),
      (arrTime = json.times),
      (arrTitle = json.title),
      (arrLink = json.url),
      (min = 0),
      (maxTitle = arrTitle.length - 1),
      (maxUser = arrUser.length - 1),
      (maxTimebuy = arrTime.length - 1),
      (StarTime = 1e3 * json.startTime),
      (StayTime = 1e3 * json.stayTime);
      document.querySelector(".sale_popup .close-popup").addEventListener("click", (r) => {
        r.preventDefault(), e.classList.remove("showPop"), clearTimeout(StayTimeout), clearTimeout(StarTimeout);
      });
      var a = () => {
        e.classList.remove("showPop"),
        (StarTimeout = setTimeout(() => {
            ((json) => {
                document.querySelector(".sale_popup .js_slpr_img").setAttribute("src", arrImage[json]),
                document.querySelector(".sale_popup .str_title-product").innerText= arrTitle[json],
                document.querySelector(".sale_popup .str_title-product").setAttribute("alt", arrTitle[json]),
                document.querySelector(".sale_popup .str_link-product").setAttribute("href", arrLink[json]),
                document.querySelector(".sale_popup .str_title-product").setAttribute("href", arrLink[json]),
                document.querySelector(".sale_popup .str_user").innerText= arrUser[t(min, maxUser)],
                document.querySelector(".sale_popup .str_time-buy").innerText= arrTime[t(min, maxTimebuy)],
                e.className += " showPop";
            })(t(min, maxTitle)),
                (StayTimeout = setTimeout(() => a(), StayTime));
        }, StarTime));
      };
      a();
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toolbar-mobile"] && !Shopify.designMode) return;
  try {
    
class settings extends HTMLElement {
    constructor() {
        super();
        this.querySelector('a').addEventListener('click', this.toggle.bind(this))
    }

    toggle() {
        if (document.documentElement.classList.contains("nav-open-additional-menu")) {
            document.documentElement.classList.remove("nav-open-additional-menu")   
        } else {
            document.documentElement.classList.add("nav-open-additional-menu")             
        }
    }
}

customElements.define('settings-custom', settings)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll( '.custom-sub-title').forEach ( (a) =>{
    a.addEventListener('click', function() {
      var questionDiv = $('.custom-sub-title');
      var answerDiv = $('.content');
      if ($(this).next().hasClass('openFAQ')) {
        $(this).removeClass('active');
        $(this).next().removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
      } else if ($(answerDiv).hasClass('openFAQ')) {
        $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
        $(questionDiv).removeClass('active');
        $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
        $(this).addClass('active');
      } else {
        $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
        $(this).addClass('active');
      }
    });
  }); 
  document.querySelectorAll( '.deferred-media__poster').forEach ( (a) =>{
    a.addEventListener('click', function() {
     $('.video-with-content-wrapper').addClass('active');
    });
  });
  document.querySelectorAll( '.collage-video__modal-toggle').forEach ( (a) =>{
    a.addEventListener('click', function() {
     $('.video-with-content-wrapper').removeClass('active');
    }); 
  });
  

  } catch(e) { console.error(e); }
})();
})();
